<template>
	<v-dialog
		:value="value"
		persistent
		width="380px">
		<v-card>
			<v-card-title class="headline py-2 px-4">
				<v-layout row wrap align-center>
					<v-flex xs12 text-xs-left>
						<p class="headline-title">
							No-show de reserva
						</p>
					</v-flex>
				</v-layout>
			</v-card-title>
			<v-card-text class="px-4">
				<v-layout row wrap
					text-xs-left>
					<v-flex xs6>
						<label class="headline-label">
							Booking ID:
						</label>
						{{ model.code }}
					</v-flex>
					<v-flex xs6>
						<label class="headline-label">
							Nombre:
						</label>
						{{ getPropValue(model, 'data', 'name') }}
						{{ getPropValue(model, 'data', 'lastname') }}
					</v-flex>
					<v-flex xs6 mt-2>
						<label class="label-title">No-show</label>
						<select-date
							icon="event"
							v-model="model.bookingDate"
						/>
					</v-flex>
					<v-flex xs12 mt-3>
						<v-checkbox
							class="input-checkbox input-booking"
							label="Facturar"
							v-model="model.flagBilling"
							color="info"
							hide-details>
						</v-checkbox>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-layout row wrap justify-center>
					<v-flex xs4 pr-2>
						<v-btn
							class="btn-cancel grey"
							@click.native="closeBookingModal">
							Cancelar
						</v-btn>
					</v-flex>
					<v-flex xs4 pl-2>
						<v-btn
							class="btn-save"
							@click.native="noShowBooking">
							Aceptar
						</v-btn>
					</v-flex>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import lib from '@/shared/lib';
import selectDate from '@/clerkinn/shared/select-date';

const { getDeeper, compose, setNewProperty } = lib;

function getPropValue(obj, ...args) {
	return getDeeper(args)(obj);
}

function closeBookingModal() {
	this.$emit('close-modal');
}

async function noShowBooking() {
	const noShowObject = this.buildNoShowObject(this.model);
	await this.$http.put(`${process.env.PMS_URL}/booking/no-show`, noShowObject);
	this.showNotification('La reserva ha sido liberada por no-show.', 'success');
	this.closeBookingModal();
}

function buildNoShowObject(model) {
	return compose(
		setNewProperty('codeBooking', model.code),
		setNewProperty('date', model.bookingDate),
		setNewProperty('flagBilling', model.flagBilling),
	)({});
}

function data() {
	return {
		date: '',
	};
}

export default {
	name: 'menu-no-show',
	components: {
		selectDate,
	},
	data,
	methods: {
		buildNoShowObject,
		closeBookingModal,
		getPropValue,
		noShowBooking,
	},
	props: {
		model: {
			default: () => {},
			type: Object,
		},
		value: null,
	},
};
</script>




// WEBPACK FOOTER //
// MenuNoShow.vue?2ae267a0